import { createAsyncThunk } from "@reduxjs/toolkit";
import { trainer } from "./tarinertype";
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const createTrainer = createAsyncThunk(
    'trainer/createTrainer',
    async (formData : trainer ,  {rejectWithValue}) =>{
        try {
           const response = await employeeServiceApiInstance.post('/trainer', formData);
          return response.data;
        } catch (error : any) {
            return rejectWithValue(error.response?.data || 'Failed to create trainer');
        }
    }
)

export const updatetrainer = createAsyncThunk(
    'trainer/updateTrainer',
    async ({ id, data }: { id: number; data: trainer }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/trainer/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update trainer');
        }
    }
);

export const fetchAlltrainer = createAsyncThunk(
    'trainer/fetchAlltrainer',
    async (_, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get('/trainer');
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch trainer');
      }
    }
  )

  export const deletetrainerById = createAsyncThunk(
    'trainer/deletetrainerById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.delete(`/trainer/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Delete');
      }
    }
  );


  export const gettrainerById = createAsyncThunk(
    'trainer/gettrainerById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/trainer/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to get');
      }
    }
  );
